import { Menu } from "../models/menu.model";
import { MenuLevel } from "../models/menu.model";
import { ResultLogin } from '../models/resultLogin.model';
import { UserModel } from "../models/user.model";
import menuLst from "../configs/menu.json";
import _ from 'lodash';

export const storageService = {
	checkRouteByMenu,
	clearUserLoggedIn,
	getAccessToken,
	getIdiom,
	getImportEntity,
	getSideNavMenus,
	getTopMenus,
	getUser,
	getUserName,
	removeImportEntity,
	setIdiom,
	setImportEntity,
	setUserLoggedIn,
	getLocale,
	updateUser,
	setLocale   
};

function checkRouteByMenu(route: string): Boolean {
	let menus = getMenus();
	let allowRoute = false;
	if (route === '/') {
		route = '/Home';
	}
	_.map(menus, (menu) => {
		if (route.toLowerCase().includes(menu.route.toLowerCase())) {
			allowRoute = true;
		}
	});

	return allowRoute;
}
function getSubMenus(): Array<MenuLevel> {
	var storageSubItem: MenuLevel[] = null;
	// Obtenha o usuário logado
	var user = getUser();

	storageSubItem = [
		// {
		// 	"idPai": 12,
		// 	"id": "12.1",
		// 	"title": "MENU_FORECAST_ANALYSIS",
		// 	"route": "forecast/deposit",
		// 	"icon": "faChartColumn"
		// },
		// // {
		// // 	"idPai": 12,
		// // 	"id": "12.2",
		// // 	"title": "MENU_INDICATOR_EXCEL",
		// // 	"route": "forecast/indicator",
		// // 	"icon": "faChartColumn"
		// // },
		// {
		// 	"idPai": 12,
		// 	"id": "12.3",
		// 	"title": "INCONSISTENT.FORECAST_ANALYSIS",
		// 	"route": "forecast/inconsistent",
		// 	"icon": "faChartColumn"
		// },
		// {
		// 	"idPai": 12,
		// 	"id": "12.4",
		// 	"title": "MENU_BELOW_IDEAL_PICKUP_SCHEDULING",
		// 	"route": "forecast/collectionSchedule",
		// 	"icon": "faChartColumn"
		// },
		// {
		// 	"idPai": 12,
		// 	"id": "12.5",
		// 	"title": "MENU_PICKED_UP_EQUIPMENT",
		// 	"route": "forecast/pickuedUpEquipment",
		// 	"icon": "faChartColumn"
		// },
		{
			"idPai": 11,
			"id": "11.1",
			"title": "MENU_INDICATORS_IMPOSE_COLLECTION",
			"route": "indicators/Imposedcollection",
			"icon": "faChartLine"
		},
		{
			"idPai": 11,
			"id": "11.2",
			"title": "MENU_INDICATORS_BALANCE_LIMIT_EXCEEDED",
			"route": "indicators/balancelimitexceeded",
			"icon": "faChartLine"
		},					
		{
			"idPai": 4,
			"id": "4.1",
			"title": "MENU_PARAMETERS",
			"icon": "faList",
			"route": "parameter"
		},
		{
			"idPai": 4,
			"id": "4.2",
			"title": "MENU_IMPOSE_COLLECTION",
			"route": "parameter/imposition",
			"icon": "faListCheck"
		},
		{
			"idPai": 4,
			"id": "4.5",
			"title": "MENU_EQUIPMENT_APPROVAL_JUSTIFICATION",
			"route": "parameter/minimumvaluepickupjustifyjustification",
			"icon": "faListCheck"
		},
		{
			"idPai": 8,
			"id": "8.1",
			"title": "MENU_EVENTS",
			"route": "event",
			"icon": "faListCheck"
		},
		{
			"idPai": 8,
			"id": "8.2",
			"title": "MENU_EVENTS_HOLIDAY",
			"route": "holiday",
			"icon": "faListCheck"
		},
		{
			"idPai": 8,
			"id": "8.3",
			"title": "MENU_EVENTS_BRANCH",
			"route": "holidaybranch",
			"icon": "faListCheck"
		},
				{
			"idPai": 10,
			"id": "10.1",
			"title": "MENU_EQUIPMENTS",
			"route": "equipment",
			"icon": "faListCheck"
		},
		{
			"idPai": 10,
			"id": "10.2",
			"title": "MENU_MULTI_EQUIPMENT_GROUP",
			"route": "equipment/multiequipmentgroup",
			"icon": "faListCheck"
		},
	];

		// Adicione os submenus condicionais
		/*
			Mostrar no menu Parametors, o menu Integração SIGA, 
			só para os usuarios com locales 2, que do Brasil
		*/
		if (user.localeId === 2) {
				storageSubItem.push({
						"idPai": 4,
						"id": "4.3",
						"title": "MENU_SIGA_SATELLITE",
						"route": "parameter/sigasatellite",
						"icon": "faListCheck"
				});
		}

		/*
			Mostrar no menu Parametors, o menu Integração SIGA, 
			só para os usuarios com locales 2, que do Brasil
		*/
		if (user.localeId != 2) {
				storageSubItem.push({
						"idPai": 4,
						"id": "4.4",
						"title": "MENU_CIT",
						"route": "parameter/cit",
						"icon": "faListCheck"
				});
		}

		if (user.profile.profileName === "admin" || user.profile.profileName === "core" || user.profile.profileName === "ctry_admin" || user.profile.profileName === "adm_reader" || user.profile.profileName === "sys_admin") {
			storageSubItem.push({
				"idPai": 12,
				"id": "12.1",
				"title": "MENU_FORECAST_ANALYSIS",
				"route": "forecast/deposit",
				"icon": "faChartColumn"
			});
		}

		if (user.profile.profileName === "admin" || user.profile.profileName === "approver" || user.profile.profileName === "adm_reader" || user.profile.profileName === "sys_admin") {
			storageSubItem.push({
				idPai: 12,
				id: "12.2",
				title: "MENU_INDICATOR_EXCEL",
				route: "forecast/indicator",
				icon: "faChartColumn"
			});
		}

		if (user.profile.profileName === "admin" || user.profile.profileName === "core" || user.profile.profileName === "ctry_admin" || user.profile.profileName === "adm_reader" || user.profile.profileName === "sys_admin") {
			storageSubItem.push({
				"idPai": 12,
				"id": "12.3",
				"title": "INCONSISTENT.FORECAST_ANALYSIS",
				"route": "forecast/inconsistent",
				"icon": "faChartColumn"
			});
			storageSubItem.push({
				"idPai": 12,
				"id": "12.4",
				"title": "MENU_BELOW_IDEAL_PICKUP_SCHEDULING",
				"route": "forecast/collectionSchedule",
				"icon": "faChartColumn"
			});	
			storageSubItem.push({
				"idPai": 12,
				"id": "12.5",
				"title": "MENU_PICKED_UP_EQUIPMENT",
				"route": "forecast/pickuedUpEquipment",
				"icon": "faChartColumn"
			});
		}
		
		return storageSubItem;
} 

function getMenus(): Array<Menu> {
	// var storageItem = localStorage.getItem("menus");
	var storageItem: Menu[] = null;

	var user = getUser();
	
	if (user.profile.profileName === "bas_prof") {
		storageItem = getMenuFromBas();
	}else{
		storageItem = menuLst.filter(menu => menu.permission.indexOf(user.profile.profileName) !== -1);
	}

	if (storageItem) {
		try {
			return storageItem;
		} catch (error) {
			console.error(error);
		}
		return null;
	}
}

export function getSideNavMenus(): Array<Menu> {
	var menus = getMenus();
	var subMenus = getSubMenus();

	menus.forEach(element => {
		element.subItem = subMenus.filter((m) => m.idPai == element.id);
	});

	var sideNavMenus = menus?.filter((m) => m.area === "lateral");

	return sideNavMenus;
}

export function getTopMenus(): Array<Menu> {
	var menus = getMenus();
	var sideNavMenus = menus.filter((m) => m.area === "superior");
	return sideNavMenus;
}

function setUserLoggedIn(result: ResultLogin): void {
	localStorage.setItem("AccessTokenDynamicPickup", result.accessToken);
	localStorage.setItem("UserName", result.user.fullName);
	localStorage.setItem("User", JSON.stringify(result.user));
	localStorage.setItem("BasPages", JSON.stringify(result.basPages));
	localStorage.setItem("Idiom", result.user.idiom.shortName);
}

function updateUser(user: UserModel): void {
	localStorage.setItem("User", JSON.stringify(user));
}

function clearUserLoggedIn(): void {
	const idiom = localStorage.getItem("Idiom");
	localStorage.removeItem("AccessTokenDynamicPickup");
	localStorage.removeItem("UserName");
	localStorage.clear();
	if (idiom) {
		localStorage.setItem("idiom", idiom);
	}
}

function getAccessToken(): string {
	return localStorage.getItem("AccessTokenDynamicPickup");
}

function getUserName(): string {
	return localStorage.getItem("UserName");
}

function getIdiom(): string {
	// Tente pegar o valor da chave "Idiom"
	let idiom = localStorage.getItem("Idiom");

	// Se "Idiom" não estiver presente, tente pegar "idiom"
	if (!idiom) {
		idiom = localStorage.getItem("idiom");
	}
	
	return idiom;
}

function getLocale(): string {
	// Tente pegar o valor da chave "Locale"
	let locale = localStorage.getItem("locale");

	// Se "Idiom" não estiver presente, tente pegar "idiom"
	if (!locale) {
		locale = localStorage.getItem("locale");
	}
	
	return locale;
}

function setLocale(locale: string) {
	localStorage.setItem("locale", locale);
}

function getUser(): UserModel {
	return JSON.parse(localStorage.getItem("User"));
}

function setIdiom(idiom: string) {
	localStorage.setItem("Idiom", idiom);
}

// -- importation-data

function getImportEntity(): string {
	return localStorage.getItem("ImportEntity");
}

function getBASPermission(): string {
	return localStorage.getItem("BasPages");
}

function removeImportEntity() {
	localStorage.removeItem("ImportEntity");
}

function setImportEntity(entity: string) {
	localStorage.setItem("ImportEntity", entity);
}

function getMenuFromBas() {
	let paginas = JSON.parse(getBASPermission());
	let mLst = [];
	paginas?.map(p => {
		if(p.componentes){
			p.componentes.map(c => {
				let menuAdd = menuLst.find(m => m.bas_permission.toLowerCase() === c.nome.toLowerCase())
				mLst.push(menuAdd);
			})
		}
	});
	return mLst;
}

export default storageService;